var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };} /* eslint-disable react/no-multi-comp */
import React from 'react';
import { Translate } from "../../../../../I18N";
import { createColumnHelper } from '@tanstack/react-table';
import { Button, Pill } from "../../../../Components/UI";






const EditButton = ({ cell, column }) => /*#__PURE__*/
_jsx(Button, {
  styling: "outline",
  onClick: () => {var _column$columnDef$met, _column$columnDef$met2;return (_column$columnDef$met = column.columnDef.meta) === null || _column$columnDef$met === void 0 ? void 0 : (_column$columnDef$met2 = _column$columnDef$met.action) === null || _column$columnDef$met2 === void 0 ? void 0 : _column$columnDef$met2.call(_column$columnDef$met, cell.row);},
  className: "leading-4" }, void 0, /*#__PURE__*/

_jsx(Translate, {}, void 0, "Edit")
);


const TitleCell = ({ cell, getValue }) => /*#__PURE__*/
_jsx("div", { className: "flex items-center gap-2" }, void 0, /*#__PURE__*/
_jsx(Translate, { className: "text-indigo-800", context: cell.row.original._id }, void 0,
getValue()
), "(",
getValue(), ")"
);


const templatesCells = ({
  cell
}) => {var _cell$getValue;return /*#__PURE__*/(
    _jsx("div", { className: "flex flex-wrap gap-2" }, void 0, (_cell$getValue =
    cell.getValue()) === null || _cell$getValue === void 0 ? void 0 : _cell$getValue.map((template) => /*#__PURE__*/
    _jsx("div", {}, cell.id + template._id, /*#__PURE__*/
    _jsx(Pill, { color: "gray", className: "whitespace-nowrap" }, void 0, /*#__PURE__*/
    _jsx(Translate, { context: template._id }, void 0, template.name)
    )
    )
    )
    ));};


const TitleHeader = () => /*#__PURE__*/_jsx(Translate, {}, void 0, "Label");
const ActionHeader = () => /*#__PURE__*/_jsx(Translate, { className: "sr-only" }, void 0, "Action");
const TemplateHeader = () => /*#__PURE__*/_jsx(Translate, {}, void 0, "Templates");

const columnHelper = createColumnHelper();
const columns = (actions) => [
columnHelper.accessor('name', {
  id: 'name',
  header: TitleHeader,
  cell: TitleCell,
  enableSorting: true,
  meta: { headerClassName: 'w-1/2' }
}),
columnHelper.accessor('templates', {
  header: TemplateHeader,
  cell: templatesCells,
  enableSorting: false,
  meta: { headerClassName: 'w-1/2' }
}),
columnHelper.accessor('key', {
  header: ActionHeader,
  cell: EditButton,
  enableSorting: false,
  meta: { action: actions.edit, headerClassName: 'w-0 text-center' }
})];

export { EditButton, TitleHeader, TitleCell, columns };